import axios, { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { BrokerOfficeListParams, BrokerOfficeListResponse } from '@/entity/BrokerOffice';
import { GET_BROKER_OFFICE_LIST } from '@/constants';
import { ErrorResponse } from '@/types';

export const useGetBrokerOfficeList = (
  searchObj?: BrokerOfficeListParams | null,
  options?: Partial<UseQueryOptions<BrokerOfficeListResponse, AxiosError<ErrorResponse>>>,
) => {
  return useQuery<BrokerOfficeListResponse, AxiosError<ErrorResponse>>({
    queryKey: options?.queryKey ?? ['broker-office-list', searchObj],
    queryFn: () =>
      axios
        .post<BrokerOfficeListResponse>(GET_BROKER_OFFICE_LIST, searchObj)
        .then((res) => res.data),
    staleTime: 30_000,
    gcTime: 0,
    ...options,
  });
};
